export default __webpack_public_path__ + "static/media/E.021eb6ac.png";